import React from 'react';
import { motion } from 'framer-motion';
export function ClosingSection() {
  return <section className="w-full bg-[#1B2A4A] text-[#FDF8F0] px-4 py-20 md:py-32 text-center" data-id="element-11">
      <div className="max-w-2xl mx-auto" data-id="element-12">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-13">
          <h2 className="text-3xl md:text-4xl font-bold font-serif mb-8 leading-tight" data-id="element-14">
            Si hoy apagar el celular te roba energía, paciencia y pareja…
          </h2>

          <p className="text-xl text-[#FDF8F0]/80 mb-8" data-id="element-15">
            No necesitas más consejos. Necesitas un plan que puedas ejecutar
            aunque estés cansado/a.
          </p>

          <p className="text-2xl font-serif italic text-[#C4704B] mb-12" data-id="element-16">
            "Y cuando la pantalla quiera volver a ser el calmante de la casa… tú
            ya vas a tener qué hacer."
          </p>

          <a href="#pricing" className="inline-block px-8 py-4 text-lg font-bold text-[#1B2A4A] bg-[#FDF8F0] rounded-full shadow-lg hover:bg-white hover:scale-105 transition-all duration-300" data-id="element-17">
            Haz el Reset 7 Días →
          </a>
        </motion.div>
      </div>
    </section>;
}